import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  listItemButton: {
    '&&': {
      paddingTop: SPACES.xs,
      paddingBottom: SPACES.xs,
      // paddingRight: SPACES.xxxs,
      paddingLeft: SPACES.xxxs,
    },
  },
  itemText: {
    '&&': {
      fontSize: FONTS.SIZES.m,
      lineHeight: 1.337,
      color: theme.palette.custom.black,

      wordWrap: 'break-word',
      wordBreak: 'break-word',
    },
  },
  collapseItem: {
    '&&': {
      marginTop: 0,

      wordWrap: 'break-word',
    },
  },
  itemPropertyText: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
    },
  },
  batchWrapper: {
    '&&': {
      display: 'flex',
      gap: SPACES.s,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  collapseItemsWrapper: {
    '&&': {
      rowGap: SPACES.l,
      display: 'flex',
      flexDirection: 'column',

      paddingLeft: '8px',
      paddingRight: '8px',
      paddingBottom: '20px',
    },
  },
}))
